'use client';

import { type useRouter } from 'next/navigation';

import { getAsPath } from '@/hooks/useRouterHistory';

export const goBack = (router: ReturnType<typeof useRouter>): void => {
  const previousPath = getAsPath().prevAsPath;

  // TODO: Implement a more robust solution for handling navigation history later on
  if (!previousPath || previousPath === '/callback') {
    router.replace('/');
  } else {
    router.back();
  }
};
